import { render, staticRenderFns } from "./propertyTenantedForm.vue?vue&type=template&id=57c449d5&%23default=true&"
import script from "./propertyTenantedForm.vue?vue&type=script&lang=js&"
export * from "./propertyTenantedForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports